import { message, notification } from "antd";

/**
 * Product decision: do not show success toasts.
 * Error/warning toasts are left unchanged.
 */

const noop = () => undefined;

export const configureAppMessages = () => {
  message.success = noop;
  notification.success = noop;
};
